/* Kalipso quantity calculator.
   Tiles are sold per square metre, so one cart unit is one m2. Every result is
   rounded up: falling short means a top-up from a different batch, which shows. */
(function () {
  'use strict';

  // the snippet may be rendered more than once on a page; bind the delegates once
  if (window.__kxqBound) return;
  window.__kxqBound = true;

  var FORMATS = [
    ['20×20', 20, 20], ['60×120', 60, 120], ['60×60', 60, 60], ['30×90', 30, 90], ['15×30', 15, 30],
    ['10×30', 10, 30], ['40×120', 40, 120], ['75×75', 75, 75], ['23×120', 23, 120], ['100×100', 100, 100],
    ['10×20', 10, 20], ['30×60', 30, 60], ['7,5×30', 7.5, 30], ['120×120', 120, 120], ['15×90', 15, 90],
    ['20×50', 20, 50], ['6×24', 6, 24], ['5×30', 5, 30], ['45×45', 45, 45], ['20×120', 20, 120],
    ['6,5×20', 6.5, 20], ['15×15', 15, 15], ['120×280', 120, 280], ['60×180', 60, 180], ['11×54', 11, 54],
    ['120×180', 120, 180], ['33,3×90', 33.3, 90], ['5×20', 5, 20], ['80×120', 80, 120]
  ];

  var nf = function (v, d) {
    return (isFinite(v) ? v : 0).toLocaleString('bg-BG', { minimumFractionDigits: d, maximumFractionDigits: d });
  };
  var num = function (el) { var v = el ? parseFloat(el.value) : NaN; return (isFinite(v) && v > 0) ? v : 0; };

  function init(dlg) {
    if (dlg.dataset.kxqReady) return;
    dlg.dataset.kxqReady = '1';

    var q = function (n) { return dlg.querySelector('[data-kxq="' + n + '"]'); };
    var uid = dlg.id.replace('kxq-', '');
    var mode = 'area', seq = 0;
    var walls = [], openings = [];

    // Floor and walls each pick their own format, everywhere. On a product page the
    // tile's own size is preselected in both, but it stays changeable - people work
    // out the whole bathroom from whichever page they happen to be on.
    var defW = q('defW'), defH = q('defH');
    var selF = q('fmtF'), selW = q('fmtW');

    var LIST = FORMATS.slice();
    var defIdx = -1;
    if (defW && defH) {
      var dw = parseFloat(defW.value), dh = parseFloat(defH.value);
      if (dw > 0 && dh > 0) {
        for (var i = 0; i < LIST.length; i++) {
          if (Math.abs(LIST[i][1] - dw) < 0.05 && Math.abs(LIST[i][2] - dh) < 0.05) { defIdx = i; break; }
        }
        // a format the shop stocks but the list does not know about yet
        if (defIdx < 0) {
          var lbl = String(dw).replace('.', ',') + '×' + String(dh).replace('.', ',');
          LIST.push([lbl, dw, dh]);
          defIdx = LIST.length - 1;
        }
      }
    }
    function fillFormats(sel, fallback) {
      if (!sel) return;
      LIST.forEach(function (f, i) {
        var o = document.createElement('option');
        o.value = i; o.textContent = f[0] + ' см';
        sel.appendChild(o);
      });
      sel.value = defIdx >= 0 ? defIdx : fallback;
    }
    fillFormats(selF, 2);   // 60x60, the commonest floor tile
    fillFormats(selW, 3);   // 30x90, the commonest wall tile

    function areaOf(sel) {
      if (!sel) return 0;
      var f = LIST[parseInt(sel.value, 10)];
      return f ? (f[1] * f[2]) / 10000 : 0;
    }
    function nameOf(sel) {
      if (!sel) return '';
      var f = LIST[parseInt(sel.value, 10)];
      return f ? f[0] + ' см' : '';
    }

    /* ---- rows ---- */
    function cell(cap, k, v, unit) {
      return '<span class="kxq-cell"><b>' + cap + '</b>' +
        '<input type="number" data-k="' + k + '" value="' + v + '" min="0" step="0.01"><i>' + unit + '</i></span>';
    }
    var m2 = function () { return '<span class="kxq-m2" data-m2>-</span>'; };
    function paintAreas() {
      var wr = q('wRows').querySelectorAll('[data-m2]');
      walls.forEach(function (w, i) {
        if (!wr[i]) return;
        var a = Math.max(0, w.len) * Math.max(0, w.h);
        wr[i].textContent = a > 0 ? nf(a, 2) + ' м²' : '-';
      });
      var or_ = q('oRows').querySelectorAll('[data-m2]');
      openings.forEach(function (o, i) {
        if (!or_[i]) return;
        var a = Math.max(0, o.a) * Math.max(0, o.b);
        or_[i].textContent = a > 0 ? '-' + nf(a, 2) + ' м²' : '-';
      });
    }
    function drawWalls() {
      var box = q('wRows'); box.innerHTML = '';
      if (!walls.length) {
        box.innerHTML = '<p class="kxq-note" style="margin:0">Няма добавени стени.</p>';
        return;
      }
      walls.forEach(function (w, i) {
        var d = document.createElement('div'); d.className = 'kxq-row';
        d.innerHTML = '<span class="n">Стена <b>' + (i + 1) + '</b></span>' +
          cell('Дължина', 'len', w.len, 'м') + cell('Височина', 'h', w.h, 'м') + m2() +
          '<button type="button" class="kxq-del" aria-label="Премахни">&times;</button>';
        d.querySelector('.kxq-del').addEventListener('click', function () {
          walls = walls.filter(function (x) { return x.id !== w.id; }); drawWalls(); calc();
        });
        d.addEventListener('input', function (e) {
          var k = e.target.getAttribute('data-k'); if (!k) return;
          w[k] = parseFloat(e.target.value) || 0; calc();
        });
        box.appendChild(d);
      });
    }
    function drawOpenings() {
      var box = q('oRows'); box.innerHTML = '';
      if (!openings.length) {
        box.innerHTML = '<p class="kxq-note" style="margin:0">Няма добавени отвори.</p>';
        return;
      }
      openings.forEach(function (o) {
        var d = document.createElement('div'); d.className = 'kxq-row minus';
        d.innerHTML = '<span class="n">- ' + o.name + '</span>' +
          cell('Ширина', 'a', o.a, 'м') + cell('Височина', 'b', o.b, 'м') + m2() +
          '<button type="button" class="kxq-del" aria-label="Премахни">&times;</button>';
        d.querySelector('.kxq-del').addEventListener('click', function () {
          openings = openings.filter(function (x) { return x.id !== o.id; }); drawOpenings(); calc();
        });
        d.addEventListener('input', function (e) {
          var k = e.target.getAttribute('data-k'); if (!k) return;
          o[k] = parseFloat(e.target.value) || 0; calc();
        });
        box.appendChild(d);
      });
    }

    function addWall(len, h) { walls.push({ id: ++seq, len: len == null ? '' : len, h: h == null ? num(q('hAll')) : h }); }
    function addOpening(name, a, b) { openings.push({ id: ++seq, name: name, a: a, b: b }); }

    q('addWall').addEventListener('click', function () { addWall(); drawWalls(); calc(); });
    q('addDoor').addEventListener('click', function () { addOpening('Врата', 0.7, 2.0); drawOpenings(); calc(); });
    q('addWin').addEventListener('click', function () { addOpening('Прозорец', 0.6, 0.6); drawOpenings(); calc(); });
    q('hAll').addEventListener('input', function () {
      var H = num(q('hAll'));
      walls.forEach(function (w) { w.h = H; });
      drawWalls(); calc();
    });

    /* ---- floor mode ---- */
    function setMode(m) {
      mode = m;
      q('mArea').setAttribute('aria-pressed', m === 'area');
      q('mSize').setAttribute('aria-pressed', m === 'size');
      q('inArea').hidden = m !== 'area';
      q('inSize').hidden = m !== 'size';
      calc();
    }
    q('mArea').addEventListener('click', function () { setMode('area'); });
    q('mSize').addEventListener('click', function () { setMode('size'); });

    /* ---- compute ---- */
    function calc() {
      var pct = parseFloat(q('pat').value) || 10;
      var floorNet = mode === 'size' ? num(q('fL')) * num(q('fW')) : num(q('fA'));
      var gross = 0, minus = 0;
      walls.forEach(function (w) { gross += Math.max(0, w.len) * Math.max(0, w.h); });
      openings.forEach(function (o) { minus += Math.max(0, o.a) * Math.max(0, o.b); });
      var wallNet = Math.max(0, gross - minus);

      // Под and Стени are the clean areas and Фира is the addition, so the figures
      // visibly add up instead of hiding the allowance inside the first two.
      var net = floorNet + wallNet;
      var waste = net * pct / 100;

      q('oFloor').textContent = nf(floorNet, 1) + ' м²';
      q('oWalls').textContent = nf(wallNet, 1) + ' м²';
      q('oWasteLbl').textContent = 'Фира ' + pct + '%';
      q('oWaste').textContent = '+ ' + nf(waste, 1) + ' м²';

      // You cannot buy 10.2 tiles. Round up to a whole tile and let the ordered
      // square metres follow from the piece count, so the figure quoted is the
      // figure delivered.
      var count = function (needArea, ta) {
        if (!(ta > 0) || !(needArea > 0)) return { pcs: 0, m2: 0 };
        var p = Math.ceil(needArea / ta);
        return { pcs: p, m2: p * ta };
      };

      var f = count(floorNet * (1 + pct / 100), areaOf(selF));
      var w = count(wallNet * (1 + pct / 100), areaOf(selW));
      q('nameF').textContent = nameOf(selF);
      q('nameW').textContent = nameOf(selW);
      q('oPcsF').textContent = f.pcs > 0 ? nf(f.pcs, 0) + ' бр.' : '-';
      q('oPcsW').textContent = w.pcs > 0 ? nf(w.pcs, 0) + ' бр.' : '-';
      q('oTotF').textContent = nf(f.m2, 2) + ' м²';
      q('oTotW').textContent = nf(w.m2, 2) + ' м²';

      paintAreas();
    }
    q('pat').addEventListener('change', calc);
    if (selF) selF.addEventListener('change', calc);
    if (selW) selW.addEventListener('change', calc);
    ['fA', 'fL', 'fW'].forEach(function (k) {
      var el = q(k); if (el) el.addEventListener('input', calc);
    });

    // four empty walls, because a bathroom has four - the numbers are the user's
    addWall(); addWall(); addWall(); addWall();
    addOpening('Врата', 0.7, 2.0);
    drawWalls(); drawOpenings(); setMode('area');
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-kxq-open]');
    if (!t) return;
    var dlg = document.getElementById('kxq-' + t.getAttribute('data-kxq-open'));
    if (!dlg) return;
    init(dlg);
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  });

  // click on the backdrop closes; clicks inside the panel must not
  document.addEventListener('click', function (e) {
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('kxq')) e.target.close();
  });
})();
